// HTML `pattern` values. Browsers compile these with the RegExp `v` flag,
// which rejects unescaped `(`, `)` and `-` inside a character class; an
// invalid pattern is silently ignored, so escape them.

export const CPCS_NUMBER_PATTERN = '^4[0-9]{7}$';

// 10 to 15 digits, optionally separated by spaces, `+`, `-` or brackets.
export const PHONE_PATTERN = '^[\\-\\+\\s\\(\\)]*(?:[0-9][\\-\\+\\s\\(\\)]*){10,15}$';

export const NIN_PATTERN = '[a-zA-Z]{2}[0-9]{6}[a-zA-Z]{1}';
